// extracted by mini-css-extract-plugin
module.exports = {"root":"CredentialsStep_root__1skDN","main":"CredentialsStep_main__1gUxg","footer":"CredentialsStep_footer__35vQH","loginButton":"CredentialsStep_loginButton__3bED8"};